import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { makeStyles, useMediaQuery } from '@ellucian/react-design-system/core';
import { useTheme } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { Typography } from '@ellucian/react-design-system/core';
const useStyles = makeStyles({
    name: 'InvalidShareUrl'
})(() => ({
    root: {
        textAlign: 'center',
        marginBottom: '4rem'
    },
}));
const desktopImage = 'https://cdn.elluciancloud.com/assets/EDS2/4.0.0/img/illustrations/large/403.png';
const mobileImage = 'https://cdn.elluciancloud.com/assets/EDS2/4.0.0/img/illustrations/large/403Narrow.png';
const Illustration = () => {
    const intl = useIntl();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const imgSrc = useMemo(() => isMobile ? mobileImage : desktopImage, [isMobile]);
    return <img alt={intl.formatMessage({ id: 'shareUrlAccessErrorImgAlt' })} src={imgSrc} />;
};

const IllustrationWrapper = Illustration;

const InvalidShareUrl = () => {
    const { classes } = useStyles();
    return (
        <div className={classes.root}>
            <IllustrationWrapper />
            <Typography variant="h1">
                <FormattedMessage id="archivedInquiryFormAccessMessageTextId" />
            </Typography>
        </div>
    );
};

export default InvalidShareUrl;
